import { React, useEffect, useState, useContext } from "react";
// import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions,changeDateFormat } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';
import { generateMiscReport } from "../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel";


const MiscReport = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [tableReportData, setTableReportData] = useState([]);
    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });

    // const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    // const decode_token = jwtDecode(token);
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();


    const storedLanguage = localStorage.getItem('language');

    //get next Years 

    //get Years 
    const getAllYears = () => {
        // const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = 2024; year >= 2010; year--) {
            yearsArray.push(year);
        }
        return yearsArray;
    };


    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level);
        setYears(getAllYears());
    }, []);

    const handleDropdownChange = (e) => {
        setYearName(e.target.value);
    };

    const handleGenerateExcel = () => {
        if (!yearName) {
            toast.error("Please select a Real Year Date", messages.COLOR_RED);
            return;
        }

        showLoading(true);
        // Prepare payload
        const payload = {
            fromYear: yearName,
        };

        // POST request to API
        axios
            .post(`${API_URL}api/price/priceAgriculturereport`, payload, config)
            .then((response) => {
                const miscReport = response.data.data.GroupCodes;


                if (!miscReport || miscReport.length === 0) {
                    toast.info("Data not found");
                    showLoading(false);
                    return;
                }

                let excelFileName = 'priceagriculturereport';
                const excelObjectData = {
                    fileName: excelFileName,
                    reportType: excelFileName,
                    fileType: 'xlsx',
                    sheetName: "ASI_Table2",
                    firstRowMergeCells: "A1:E1",
                    firstRowExportDate:  changeDateFormat(new Date()),
                    firstRowCellNumber: 5,
                    secondRowMergeCells: "A2:E2",
                    secondRowText: `भू  राजस्व  कर (लेखा  शीर्षक ) (आधार वर्ष 2011-12=100)`,
                    headerHindiColumns: [
                        'लेखा', 'शीर्षक ', 'आधार  भाव 2011', `${parseInt(yearName) - 1}`, `${yearName}`
                    ],
                };

                const transformedData = miscReport.map((item, index) => [
                    index + 1,
                    item.col1,
                    item.col2,
                    item.col3,
                    item.col4,
                ]);
                excelObjectData.excelRowData = transformedData;

                generateMiscReport(excelObjectData);

                showLoading(false);
            })
            .catch((error) => {
                // Handle error if needed
                console.error('API Error:', error);
                showLoading(false);
            });
    };

    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                        <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.MISC_REPORT : priceTitle.en.MISC_REPORT }} />
              
                    </h4>
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                    Select Real Year Date
                                    </label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleDropdownChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {years &&
                                            years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                    {ele}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default MiscReport